module.exports = __webpack_public_path__ + "static/media/custom-fields.5dffd4cc.svg";